import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SaldoItemStatus } from './SaldoItem';

const getBackgroundColor = (status: SaldoItemStatus, theme: any) => {
  if (status === SaldoItemStatus.WARNING) {
    return theme.palette.warning.light;
  }

  if (status === SaldoItemStatus.DANGER) {
    return theme.palette.error.ultraLight;
  }

  return '#EAF2FD';
};

type IconWrapperProps = {
  status: SaldoItemStatus;
};

export const IconWrapper = styled('div')<IconWrapperProps>(({ status, theme }) => ({
  width: '3.5rem',
  height: '3.5rem',
  maxWidth: '56',
  maxHeight: '56',
  backgroundColor: getBackgroundColor(status, theme),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px'
}));

export const LabelWrapper = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  color: theme.palette.sectionHeader.primary
}));

export const AmountWrapper = styled(Typography)(({ theme }) => ({
  fontSize: '2rem',
  color: theme.palette.text.primary,
  fontWeight: 600
}));
